export default "__VITE_ASSET__9e1083ea__"